import type { ApiExecutionStatus } from '@mls-wallet/shared-types';

interface TransactionExecutionStateInput {
  executionStatus: ApiExecutionStatus;
  isLocallyTracked: boolean;
  isRequestPending: boolean;
}

/**
 * Combines the immediate request state, the persistent local tray identity,
 * and the server-polled status used by other organization members.
 */
export function isTransactionExecutionInProgress({
  executionStatus,
  isLocallyTracked,
  isRequestPending,
}: TransactionExecutionStateInput): boolean {
  return (
    isRequestPending || isLocallyTracked || executionStatus === 'processing'
  );
}

/**
 * Keeps the historic feed live while queued details are open so a transaction
 * can move out of the queue without leaving the sheet on stale execution data.
 */
export function shouldPollHistoricTransactions(
  currentTab: 'queued' | 'historic',
  isDetailSheetOpen: boolean
): boolean {
  return currentTab === 'historic' || isDetailSheetOpen;
}
